import { render, staticRenderFns } from "./SquareCombookBindingFrame.vue?vue&type=template&id=3ac681a3&scoped=true&"
import script from "./SquareCombookBindingFrame.vue?vue&type=script&lang=js&"
export * from "./SquareCombookBindingFrame.vue?vue&type=script&lang=js&"
import style0 from "./SquareCombookBindingFrame.vue?vue&type=style&index=0&id=3ac681a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac681a3",
  null
  
)

export default component.exports